import { orderBy } from 'lodash'

export const getDealTasks = ({ all }) => orderBy(all, ['due_date_at'], ['desc'])



// WEBPACK FOOTER //
// ./src/modules/deals/components/show/tasks/store/getters.js